import React from 'react';

export default function toggleDialog(WrappedComponent) {
    class ToggleDialog extends React.Component {
        constructor(props) {
            super(props);
            this.state = {
                isDialogOpen: false,
            };
        }

        toggleDialog = () => {
            this.setState(state => ({
                isDialogOpen: !state.isDialogOpen,
            }));
        };

        render() {
            const { isDialogOpen } = this.state;

            return (
                <WrappedComponent
                    {...this.props}
                    toggleDialog={this.toggleDialog}
                    isDialogOpen={isDialogOpen}
                />
            );
        }
    }

    return ToggleDialog;
}



// WEBPACK FOOTER //
// ./src/hoc/ToggleDialog.js